@if(spinner()){
  <div class="h-dvh w-screen fixed top-0 left-0 bg-black/5 backdrop-blur flex items-center justify-center">
    <div class="h-20 aspect-square border-6 border-t-transparent animate-spin rounded-full border-primary-dark relative">
    </div>
</div>
}
